/* eslint-disable key-spacing */
/**
 * @author: 陈基涛
 * @date: 2022
 * @description: 暴露出多个 API 接口链接，包括
 * * www       fzs域名
 * * secKill   秒杀
 * * order     订单
 * * promotion 促销(秒杀)
 */
const ApiMap = {
  '0': {
    www:       'http://dev.www.phone580.com/',
    secKill:   'http://dev.www.phone580.com/',
    order:     'http://dev.www.phone580.com/',
    promotion: 'http://dev.promotionapi.phone580.com:8000/',
    bi:        'http://dev.www.phone580.com/',
  },
  '1': {
    www:       'http://test.www.phone580.com:8000/',
    secKill:   'http://test.www.phone580.com:8000/',
    order:     'http://test.www.phone580.com:8000/',
    promotion: 'https://test.promotionapi.phone580.com:8000/',
    bi:        'http://test.www.phone580.com:8000/',
  },
  '2': {
    www:       'https://www.phone580.com/',
    secKill:   'https://seckillapi.phone580.com/',
    order:     'https://orderapi.phone580.com/',
    promotion: 'https://promotionapi.phone580.com/',
    bi:        'https://bi.phone580.com/'
  },
  '3': {
    www:       'https://www.phone580.com/',
    secKill:   'https://seckillapi.phone580.com/',
    order:     'https://orderapi.phone580.com/',
    promotion: 'https://promotionapi.phone580.com/',
    bi:        'https://bi.phone580.com/'
  }
}

export default ApiMap
